import {CockpitCard} from '../../../../shared/dtos/cockpit-card';
import {TEMOST_CONST} from '../../../../shared/EnumsConstants/global-enum';
import {DataStorageService} from '../../../../shared/services/data-storage.service';
import {DownloadService} from '../../../../shared/services/download.service';
import {ExportDataService} from '../../../../shared/services/export-data.service';

import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {CockpitContentComponent} from '../../cockpit-content-component';
import {AnalyticsInjectorService} from '../../../../shared/services/analytics/analytics.injector.service';

@Component({
  selector: 'app-chart-dialog-einfuehrung-und-download',
  templateUrl: './chart-dialog-einfuehrung-und-download.component.html',
  styleUrl: './chart-dialog-einfuehrung-und-download.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ChartDialogEinfuehrungUndDownloadComponent
  implements OnInit, CockpitContentComponent
{
  card: CockpitCard;
  exportCockpit: () => void;

  constructor(
    private readonly download: DownloadService,
    private readonly exportDataService: ExportDataService,
    private readonly storage: DataStorageService,
    private readonly translate: TranslateService,
    private readonly analyticsInjector: AnalyticsInjectorService
  ) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
  async ngOnInit(): Promise<void> {}

  async downloadExportDataList() {
    const isModule2 = await this.storage.getIsForModule2();
    const module = isModule2 ? 'M2' : 'M1';
    const title = `Logib Export Datasheet ${module}`;
    this.analyticsInjector.init(title);

    const sender = isModule2
      ? TEMOST_CONST.Sender.Module2
      : TEMOST_CONST.Sender.Module1;
    this.exportDataService.getData().then(data => {
      this.download.exportExcelAnalyseData(
        data,
        this.translate.currentLang,
        sender,
        module
      );
    });
  }
}
